import * as React from 'react';
export * from './tabs-default';
export * from './tabs-shadow';

export interface ITabItemProps extends React.HTMLAttributes<HTMLSpanElement> {
  title: string;
  badges?: string;
}

export const TabItem = React.forwardRef<HTMLSpanElement, ITabItemProps>(
  (props, ref) => <span {...props} ref={ref} />,
);
